const normalizeStatusText = (value = "") => {
  if (typeof value === "string") {
    return String(value || "").trim().toLowerCase();
  }

  if (value && typeof value === "object") {
    return String(value.status || value.text || value.label || "")
      .trim()
      .toLowerCase();
  }

  return "";
};

const includesAnyKeyword = (value = "", keywords = []) =>
  keywords.some((keyword) => String(value || "").includes(keyword));

const createStatusMeta = (key, label, className, animate = false) => ({
  key,
  label,
  className,
  animate,
  displayStatus: label,
  badgeColor: className,
  isCancelled: key === "cancelled" || key === "abandoned",
});

export const getDisplayMatchStatusMeta = (match = {}) => {
  const status = normalizeStatusText(match?.status);
  const apiStatus = normalizeStatusText(
    match?.apiStatus || match?.event_status || match?.api_status
  );
  const statusInfo = normalizeStatusText(
    match?.statusInfo || match?.status_info || match?.statusText
  );

  const overrideText = `${apiStatus} ${statusInfo}`.trim();

  if (
    includesAnyKeyword(overrideText, ["abandoned"]) ||
    includesAnyKeyword(status, ["abandoned"])
  ) {
    return createStatusMeta(
      "abandoned",
      "ABANDONED",
      "bg-secondary text-white"
    );
  }

  if (
    includesAnyKeyword(overrideText, ["cancelled", "canceled", "no result"]) ||
    includesAnyKeyword(status, ["cancelled", "canceled"])
  ) {
    return createStatusMeta(
      "cancelled",
      "CANCELLED",
      "bg-secondary text-white"
    );
  }

  if (
    includesAnyKeyword(`${status} ${apiStatus}`.trim(), [
      "completed",
      "finished",
      "result",
    ])
  ) {
    return createStatusMeta(
      "completed",
      "COMPLETED",
      "bg-success text-white"
    );
  }

  if (
    status === "live" ||
    includesAnyKeyword(status, ["live", "in progress", "inprogress"])
  ) {
    return createStatusMeta("live", "LIVE", "bg-danger text-white", true);
  }

  return createStatusMeta("upcoming", "UPCOMING", "bg-warning text-dark");
};
